import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";

/**
 * Where a code goes (owner 2026-10-25): SMS only, Email only or Both. ONE code
 * made by radaccess goes out on each channel chosen and either delivery works.
 * Default SMS; nothing is remembered. Email reaches only a VERIFIED address --
 * the server says so when there is none.
 */
export type CodeChannel = "sms" | "email" | "both";

export const codeChannels = (c: CodeChannel): ("sms" | "email")[] => (c === "both" ? ["sms", "email"] : [c]);

export function CodeChannelChoice(props: { value: CodeChannel; onChange: (c: CodeChannel) => void; disabled?: boolean }) {
  return (
    <FormControl disabled={props.disabled ?? false}>
      <FormLabel id="code-channel-label" sx={{ fontSize: 13 }}>
        Send the code by
      </FormLabel>
      <RadioGroup
        row
        aria-labelledby="code-channel-label"
        value={props.value}
        onChange={(e) => props.onChange(e.target.value as CodeChannel)}
      >
        <FormControlLabel value="sms" control={<Radio size="small" />} label="SMS" />
        <FormControlLabel value="email" control={<Radio size="small" />} label="Email" />
        <FormControlLabel value="both" control={<Radio size="small" />} label="Both" />
      </RadioGroup>
      {props.value !== "sms" && (
        <FormHelperText sx={{ mx: 0 }}>Email works only when your login has a verified email address.</FormHelperText>
      )}
    </FormControl>
  );
}

/** "Code sent by SMS to +91 98•••••210 and by email to aj•••@gmail.com." */
export function codeSentLine(maskedMobile: string, sms: boolean, email: string | undefined): string {
  const parts: string[] = [];
  if (sms) parts.push(`by SMS to ${maskedMobile}`);
  if (email) parts.push(`by email to ${email}`);
  return parts.length ? `Code sent ${parts.join(" and ")}.` : "Code sent.";
}
